/** A trust schema. */
export class TrustSchema {
    policy;
    trustAnchors;
    constructor(policy, trustAnchors) {
        this.policy = policy;
        this.trustAnchors = trustAnchors;
    }
}
